module.exports = __webpack_public_path__ + "img/Case_2.354c5352.jpg";